import { jsx as _jsx } from "react/jsx-runtime";
import PublicOfferRu from "../../components/PublicOfferRu.js";
const Offer = () => {
    return (_jsx("article", { className: "prose dark:prose-invert prose-zinc prose-sm", children: _jsx(PublicOfferRu, {}) }));
};
export default Offer;
